import { TmBaseError } from '@/core/error/tmBaseError'

export class TmRuntimeError extends TmBaseError {
  public name = 'TmRuntimeError'
}
